module.exports = __webpack_public_path__ + "img/IMG-20200319-WA0071.6db67bd2.jpg";